import Reveal from '@/pages/zz-review/components/Reveal';

const statuses = [
  {
    name: '《1001旋轉門》',
    status: 'Publication Ready',
    detail: '360 頁書稿與排版完成，進入出版發行準備。',
    dot: 'bg-primary-500',
  },
  {
    name: 'RG Portal',
    status: 'Beta / In Development',
    detail: '核心實踐入口階段性建置與測試中。',
    dot: 'bg-foreground-300',
  },
  {
    name: '《一之門》',
    status: 'Coming Next',
    detail: '持續編寫中。',
    dot: 'bg-background-300',
  },
  {
    name: 'AUM1001 Matrix',
    status: 'Public Entry',
    detail: '官方入口網站階段性上線。',
    dot: 'bg-primary-400',
  },
];

export default function StatusSection() {
  return (
    <section id="status" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              Project Status
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              專案目前進度
            </h2>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {statuses.map((item) => (
              <div
                key={item.name}
                className="rounded-lg border border-background-200/70 bg-background-100 px-5 py-5 flex items-start gap-4"
              >
                <span className={`w-2.5 h-2.5 rounded-full mt-1.5 shrink-0 ${item.dot}`} />
                <div>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mb-1">
                    <span
                      className="text-base md:text-lg text-foreground-900 font-medium"
                      style={{ fontFamily: 'var(--font-heading)' }}
                    >
                      {item.name}
                    </span>
                    <span className="text-xs text-primary-700 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {item.status}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500">{item.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}